export function  MapboxPopupContent({ 
    title, 
    address, 
    closed,
    subcategory = "No Data", 
    lease = "No Data", 
    buy = "No Data", 
    isHighEstimation = false,
    Img,
    segmentInd,
    coordinates,
    id,
    ranking,
    category,
    analyzeLocation,
  })  {
    const numberWithCommas = (num) => {
        if (num === null || num === undefined || num === "No Data") return "No Data";
        return "$" + num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      };
      const imageFallback = [
        'Automotive', 'Business', 'Community',
        'Education', 'Entertainment', 'Finance', 
        'Fitness', 'Food & Drink', 'Hotel',
        'Medical Institution', 'Rental Shop', 'Services', 
        'Shop', 'Sports & Outdoors', 'Supermarket',
        'Wellness and Beauty', 'Wellness and Health'
      ];
      
      // Get image source based on category
      const categoryName = category !== "No Data" ? category : subcategory;
      const getImageSrc = () => {
        if (Img) return Img;
        return imageFallback.includes(categoryName) ? 
          `SegmentationIcons/${categoryName}.png` : 
          'SegmentationIcons/default.png';
      };
    
      // Format lease and buy values if they're not already formatted
      const formattedLease = typeof lease === 'number' ? numberWithCommas(lease) : lease;
      const formattedBuy = typeof buy === 'number' ? numberWithCommas(buy) : buy;
    
      return (
        <div style={{
          backgroundColor: 'white',
          color: 'black',
          borderRadius: '12px',
          padding: '20px',
          width: '100%',
          maxWidth: '320px'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '16px'
          }}>
        <div className='container-small-image'>
          <img 
            src={getImageSrc()}
            alt={categoryName}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = 'SegmentationIcons/default.png';
            }}
          />
        </div>
            <span style={{ fontSize: '18px', fontWeight: 'bold' }}>{title || "No Data"}</span>
          </div>
          
          <div style={{
            backgroundColor: closed ? 'red' : '#2D5BBA' ,
            color: 'white',
            borderRadius: '20px',
            padding: '6px 16px',
            display: 'inline-block',
            marginBottom: '16px',
            fontSize: '14px'
          }}>
            {closed ? 'Closed' : 'Open' }
          </div>
          
          <div style={{ 
            fontSize: '16px',
            marginBottom: '16px',
            color: '#8d8d8d'
          }}>
            {address}
          </div>
          
          <div style={{ 
            fontSize: '18px',
            fontWeight: 'bold',
            marginBottom: '16px'
          }}>
            Type: {subcategory}
          </div>
          {<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
            <span style={{ color: '#8d8d8d' }}>Ranking:</span>
            <span style={{ fontWeight: 'bold' }}>{ranking}</span>
          </div>}
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
            <span style={{ color: '#8d8d8d' }}>Est. Lease:</span>
            <span style={{ fontWeight: 'bold' }}>{formattedLease}</span>
          </div>
          
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '24px' }}>
            <span style={{ color: '#8d8d8d' }}>Est. Cost:</span>
            <span style={{ fontWeight: 'bold' }}>{formattedBuy}</span>
          </div>
          
          {isHighEstimation && 
            <div style={{ color: '#FFC72C', marginBottom: '16px' }}>
              Real Estate estimation is high
            </div>
          }
          
          {segmentInd && <button style={{
            backgroundColor: '#4285F4',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            padding: '12px 15px',
            width: '100%',
            fontSize: '16px',
            fontWeight: 'bold',
            cursor: 'pointer'
          }} onClick={()=> analyzeLocation(id, coordinates, Img, title, address, category)}>
            Analyze Location
          </button>}
        </div>
      );
  };
  
  